// Form field configurations for application management

export const studentFieldsConfig = [
  {
    key: 'APF_FirstName',
    label: 'First Name',
    type: 'text',
    span: 1,
    required: true,
  },
  {
    key: 'APF_Surname',
    label: 'Last Name',
    type: 'text',
    span: 1,
    required: true,
  },
  {
    key: 'APF_Preferred_Name',
    label: 'Preferred Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_DOB',
    label: 'Date of Birth',
    type: 'date',
    span: 1,
    required: true,
  },
  {
    key: 'APF_CommencementDate',
    label: 'Commencement Date',
    type: 'date',
    span: 1,
    required: true,
  },
  {
    key: 'APF_Gender',
    label: 'Gender',
    type: 'select',
    span: 1,
    options: [
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
    ],
    required: true,
  },
  {
    key: 'APF_POB',
    label: 'Country of Birth',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_Nationality',
    label: 'Nationality',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_DualCitizenship',
    label: 'Dual Citizenship',
    type: 'text',
    span: 1,
    condition: form => form.APF_DualCitizenship,
  },
  {
    key: 'APF_CurrentSchool',
    label: 'Current School Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_CurrentCountry',
    label: 'Current School Country',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_EnrolPreviously',
    label: 'Has your child been enrolled with EtonHouse previously?',
    type: 'select',
    span: 2,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
  },
  {
    key: 'APF_EnrolPreviouslySchool',
    label: "Child's Previously Enrolled School",
    type: 'school-select',
    span: 1,
    condition: form => form.APF_EnrolPreviously === 'yes',
  },
  {
    key: 'APF_EnrolPreviouslySchoolYear',
    label: 'Previously Enrolled Year',
    type: 'text',
    span: 1,
    readonly: true,
    condition: form => form.APF_EnrolPreviouslySchoolYear,
  },
  {
    key: 'APF_PassportNumber',
    label: 'Passport No.',
    type: 'text',
    span: 1,
    readonly: true,
    condition: form => form.APF_PassportNumber,
  },
  {
    key: 'APF_PassportExpiryDate',
    label: 'Passport Expiry Date',
    type: 'date',
    span: 1,
    readonly: true,
    condition: form => form.APF_PassportExpiryDate,
  },
  {
    key: 'APF_IDType',
    label: 'Immigration Status',
    type: 'select',
    span: 1,
    options: [
      { value: 'DP(Dependant Pass)', label: "Dependent's Pass" },
      { value: 'LTVP(Long Term Visit Pass)', label: 'Long Term Visit Pass' },
      { value: 'PR(Permanent Resident)', label: 'Permanent Resident' },
      { value: 'STPIP(Student Pass In Progress)', label: "Student's Pass In Progress" },
      { value: 'SC(Citizen)', label: 'Singapore Citizen' },
      { value: 'STP(Student Pass)', label: "Student's Pass" },
      { value: 'Immigration Exemption Order', label: 'Immigration Exemption Order' },
    ],
  },
  {
    key: 'APF_IDNumber',
    label: 'Document No.',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_IDPASSIssueDate',
    label: 'Issue Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APF_IDPASSExpiredDate',
    label: 'Expiry Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APF_1stLang',
    label: 'First(1st) Language',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_2ndLang',
    label: 'Second(2nd) Language (if applicable)',
    type: 'text',
    span: 1,
    condition: form => form.APF_2ndLang,
  },
  {
    key: 'APF_BilingualProgram',
    label: 'Bilingual (English & Mandarin) Immersion Programme',
    type: 'select',
    span: 1,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    key: 'APF_AdditionalLanguage',
    label: 'Additional Language (Main Curriculum Only)',
    type: 'text',
    span: 1,
    condition: form => form.APF_BilingualProgram === 'No',
  },
  {
    key: 'APF_Language',
    label: 'Language',
    type: 'text',
    span: 1,
    condition: form => form.APF_Language,
  },
  {
    key: 'APF_EnglishReadingProficiency',
    label: 'English Proficiency - Reading',
    type: 'text',
    span: 1,
    condition: form => form.APF_EnglishReadingProficiency,
  },
  {
    key: 'APF_EnglishWritingProficiency',
    label: 'English Proficiency - Writing',
    type: 'text',
    span: 1,
    condition: form => form.APF_EnglishWritingProficiency,
  },
  {
    key: 'APF_EnglishSpeakingProficiency',
    label: 'English Proficiency - Speaking',
    type: 'text',
    span: 1,
    condition: form => form.APF_EnglishSpeakingProficiency,
  },
  {
    key: 'APF_TrafficChannel',
    label: 'How did you hear about our school?',
    type: 'text',
    span: 2,
  },
  {
    key: 'APFP_PrimaryParent',
    label: 'Primary contact for contracts, billing, school reports, email correspondence, etc.',
    type: 'text',
    span: 2,
  },
  {
    key: 'APF_DeclarePublication',
    label:
      'Consent to EtonHouse to include student in publications, promotional photos/videos, IB materials, and social media postings not limited to Facebook, Instagram, TikTok or Youtube within Singapore and internationally.',
    type: 'text',
    span: 2,
  },
]

export const fatherFieldsConfig = [
  {
    key: 'APFP_FatherFirstName',
    label: 'First Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherLastName',
    label: 'Last Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherMiddleName',
    label: 'Middle Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherNationality',
    label: 'Nationality',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherPersonalEmail',
    label: 'Email',
    type: 'email',
    span: 2,
  },
  {
    key: 'APFP_FatherMobile',
    label: 'Tel (M)',
    type: 'tel',
    span: 1,
  },
  {
    key: 'APFP_FatherHomeTel',
    label: 'Tel (H)',
    type: 'tel',
    span: 1,
  },
  {
    key: 'APFP_FatherResidencyStatus',
    label: 'Residency Status',
    type: 'text',
    span: 1,
    condition: form => form.APFP_FatherResidencyStatus,
  },
  {
    key: 'APFP_FatherResidencyDocNo',
    label: 'Passport / FIN / NRIC No.',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherResidencyDocExpiry',
    label: 'Expiry Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APFP_FatherResidencyDocIssueDate',
    label: 'Issue Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APFP_FatherCompanyName',
    label: 'Company Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_FatherOccupation',
    label: 'Occupation',
    type: 'text',
    span: 1,
  },
]

export const motherFieldsConfig = [
  {
    key: 'APFP_MotherFirstName',
    label: 'First Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherLastName',
    label: 'Last Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherMiddleName',
    label: 'Middle Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherNationality',
    label: 'Nationality',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherPersonalEmail',
    label: 'Email',
    type: 'email',
    span: 2,
  },
  {
    key: 'APFP_MotherMobile',
    label: 'Tel (M)',
    type: 'tel',
    span: 1,
  },
  {
    key: 'APFP_MotherHomeTel',
    label: 'Tel (H)',
    type: 'tel',
    span: 1,
  },
  {
    key: 'APFP_MotherResidencyStatus',
    label: 'Residency Status',
    type: 'text',
    span: 1,
    condition: form => form.APFP_MotherResidencyStatus,
  },
  {
    key: 'APFP_MotherResidencyDocNo',
    label: 'Passport / FIN / NRIC No.',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherResidencyDocExpiry',
    label: 'Expiry Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APFP_MotherResidencyDocIssueDate',
    label: 'Issue Date',
    type: 'date',
    span: 1,
  },
  {
    key: 'APFP_MotherCompanyName',
    label: 'Company Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_MotherOccupation',
    label: 'Occupation',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_AnnualHouseHoldIncome',
    label: 'Household Income',
    type: 'text',
    span: 1,
  },
]

export const guardianFieldsConfig = [
  {
    key: 'APFP_LegalGuardianName',
    label: 'Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APFP_LegalGuardianEmail',
    label: 'Email',
    type: 'email',
    span: 1,
  },
  {
    key: 'APFP_LegalGuardianMobile',
    label: 'Tel (M)',
    type: 'tel',
    span: 1,
  },
  {
    key: 'APFP_LegalGuardianHomeTel',
    label: 'Tel (H)',
    type: 'tel',
    span: 1,
  },
]

export const correspondenceFieldsConfig = [
  {
    key: 'APF_CorrPrimaryContact',
    label: 'Primary contact for all',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_CorrResidingWith',
    label: 'Student will be residing with',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_CorrAddress',
    label: 'Address',
    type: 'textarea',
    span: 2,
  },
  {
    key: 'APF_CorrPostal',
    label: 'Postal',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_CorrCountry',
    label: 'Country',
    type: 'text',
    span: 1,
  },
]

export const billingFieldsConfig = [
  {
    key: 'APF_BillingName',
    label: 'Billing Name',
    type: 'text',
    span: 2,
  },
  {
    key: 'APF_BillingAddress',
    label: 'Address',
    type: 'textarea',
    span: 2,
  },
  {
    key: 'APF_BillingPostal',
    label: 'Postal',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_BillingCountry',
    label: 'Country',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_BillingEmail',
    label: 'Email',
    type: 'email',
    span: 1,
  },
  {
    key: 'APF_BillingTel',
    label: 'Tel',
    type: 'tel',
    span: 1,
  },
]

export const referralFieldsConfig = [
  {
    key: 'APF_ReferralAgentName',
    label: 'Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_ReferralAgentEmail',
    label: 'Email',
    type: 'email',
    span: 1,
  },
  {
    key: 'APF_ReferralCompany',
    label: 'Company Name',
    type: 'text',
    span: 1,
  },
  {
    key: 'APF_ReferralAgentTel',
    label: 'Tel',
    type: 'tel',
    span: 1,
  },
]
